// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._1r2NyJ0waWJ6hY {\n  font-size: 12px;\n  line-height: 14px;\n  margin: 0 0 6px;\n  color: #6B778C;\n  white-space: pre;\n}\n._1v-H_0oIq6jZZL {\n  color: inherit;\n  text-decoration: none;\n}\n._1v-H_0oIq6jZZL:hover {\n  text-decoration: underline;\n}\n._1b1eN_tGDQHbqz {\n  margin-right: 1px;\n  vertical-align: middle;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"notificationAppCreator": "_1r2NyJ0waWJ6hY",
	"quiet": "_1v-H_0oIq6jZZL",
	"appCreatorIconContainer": "_1b1eN_tGDQHbqz"
};
export default ___CSS_LOADER_EXPORT___;
